import React, {useEffect, useRef, useState} from "react";
import Dialog from "../../base/dialog";
import {DialogActions, DialogContent, DialogTitle, Divider, Fade} from "@mui/material";
import ManageTagIcon from "../../app-specific/manage-tag-icon";
import Button from "../../base/button/button";
import useIsMounted from "../../../hooks/use-is-mounted";

const ManageTagIconDialog = ({open, close, tag, updateTagIconUrl}) => {
    const [submitting, setSubmitting] = useState(false);
    const [changed, setChanged] = useState(false);
    const isMounted = useIsMounted();
    const manageTagIconRef = useRef();

    /**
     * With each change in the open prop of the dialog:
     * - if the dialog is closed, then sets the changed state to false.
     */
    useEffect(() => {
        if (!open) {
            setChanged(false);
        }
    }, [open])

    /**
     * Saves the changes made in the dialog.
     */
    const saveChanges = async () => {
        setSubmitting(true);
        const resultFlag = await manageTagIconRef.current?.commit();
        if (!isMounted())
            return;
        setSubmitting(false);
        if (resultFlag) {
            close();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                setOpen={() => close()}
                maxWidth={'sm'}
                className={'bound-dialog'}
                loading={submitting}
                disableEscapeKeyDown={submitting}
                disableBackdropClick={submitting}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        Manage {tag?.name ?? ''}'s Icon
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent className={'px-4 mb-4 mt-3'}>
                    <ManageTagIcon
                        preventAutoCommit
                        tagId={tag?.id}
                        tagUrl={tag?.iconFileName}
                        updateTagIconUrl={(fileName) => updateTagIconUrl && updateTagIconUrl(fileName)}
                        onChangesMade={setChanged}
                        ref={manageTagIconRef}
                    />
                </DialogContent>
                <Divider className='divider'/>
                <DialogActions className={'d-flex align-items-center justify-content-between'} sx={{padding: 0}}>
                    <Button
                        variant={'dialog'}
                        color={'primary'}
                        onClick={() => close()}
                        borderRadius={'0 8px 0 8px'}
                    >
                        Close
                    </Button>
                    <Fade in={!!changed}>
                        <Button
                            disabled={submitting}
                            variant={'dialog'}
                            color={'primary'}
                            onClick={() => saveChanges()}
                            borderRadius={'8px 0 8px 0'}
                        >
                            {
                                submitting
                                    ? "Saving..."
                                    : "Save Changes"

                            }
                        </Button>
                    </Fade>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ManageTagIconDialog;
